import styled from '@emotion/styled'
import chroma from 'chroma-js'
import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react'

import { Colors } from 'src/components/theme'

const Container = styled.div`
  background-color: ${Colors.bgWhite};
  box-shadow:
    0px 4px 8px -2px ${chroma(Colors.neutral950).alpha(0.1).hex()},
    0px 2px 4px -2px ${chroma(Colors.neutral950).alpha(0.06).hex()};
  border-radius: 8px;
`

const ContentContainer = styled.div`
  padding-top: 16px;
  padding: 20px;
`

const HeadingContainer = styled(ContentContainer)`
  padding-top: 20px;
  padding-bottom: 12px;
  border-bottom: solid 1px ${Colors.neutral100};
`

export type ChipProps = PropsWithChildren<{
  tab?: React.ReactNode
  heading?: React.ReactNode
}> &
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export const MapTooltip = ({ tab, heading, children, ...containerProps }: ChipProps) => {
  return (
    <Container {...containerProps}>
      {tab}
      {heading && <HeadingContainer>{heading}</HeadingContainer>}
      <ContentContainer>{children}</ContentContainer>
    </Container>
  )
}
